import { render, staticRenderFns } from "./WhatCamera.vue?vue&type=template&id=6dc3fda6&"
import script from "./WhatCamera.vue?vue&type=script&lang=js&"
export * from "./WhatCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports